import { async } from "q";
import { attendenace } from "../Reducers/attendance_reducer";
import { EMP_ATTENDANCE } from "../action_types";
import moment from "moment";
let token = JSON.parse(localStorage.getItem('key'));
let SERVER_URL = process.env.REACT_APP_API_URL;
export const attendenace_action = (state) => async (dispatch) => {



    const response = await fetch(SERVER_URL + `api/attendance/my-attendance-list`,
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                EmpID: state.emp_id,
                FindMonth: state.date
            })
        }).then(res => res.json())
        .then(data => {
            var attendenace_arr = new Array();
            data.data?.map((item, index) => {
                attendenace_arr[item.day] = item;
                attendenace_arr.push()

                if (item.count > 1) {
                    var att_date = moment(item.att_date).format('YYYY-MM-DD')
                    get_in_out_inDay(att_date, item.day)
                }
            })




            var holiday_arr = new Array();
            data.officeHoliday?.map((item, index) => {
                holiday_arr[item.day] = item;
                holiday_arr.push()
            })

            var in_out = new Array()
            async function get_in_out_inDay(att_date, att_day) {
                await fetch(SERVER_URL + `api/attendance/day-in-out`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                    body: JSON.stringify({
                        EmpID: state.emp_id,
                        att_date: att_date
                    })
                }).then(res => res.json()).
                    then(data => {
                        in_out[att_day] = data.data;
                        in_out.push()
                    })
            }


            dispatch({ type: EMP_ATTENDANCE, payload: { attendenace_arr, holiday_arr, in_out } })
        });

}
export const get_Today_attendance_time = (userId) => async (dispatch) => {
    var att_date = moment().format("YYYY-MM-DD");
    var today_time = new Array()
    await fetch(SERVER_URL + `api/attendance/today-attendance-time`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
            EmpID: userId,
            att_date: att_date
        })
    }).then(res => res.json()).
        then(data => {
            today_time['TodayHRS'] = data.data;
            today_time.push()
        })
    dispatch({ type: 'EMP_TODAT_ATTENDANCE_TIME', payload: { today_time } })
}
export const get_punch_in_time = (userId) => async (dispatch) => {

    var att_date = moment().format("YYYY-MM-DD");
    await fetch(SERVER_URL + `api/attendance/today-punch-in-time`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
            EmpID: userId,
            att_date: att_date
        })
    }).then(res => res.json()).
        then(data => {
            const currentTime = moment().format('HH:mm:ss a');
            var startTime = moment(data?.data, 'HH:mm:ss a');
            var endTime = moment(currentTime, 'HH:mm:ss a');

            var DiffAB = endTime.diff(startTime);
            //  console.log(DiffAB / 1000)

            dispatch({ type: 'SET_EMP_PUNCH_TIME_IN', payload: { DiffAB } })

        })
}
export const get_Punch_Time_In_Month = (userId) => async (dispatch) => {
    const from_date = moment().format('YYYY-MM') + '-1';
    const to_date = moment().format('YYYY-MM') + '-' + moment().daysInMonth()


    await fetch(SERVER_URL + `api/attendance/punch-time-in-month`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
            EmpID: userId,
            from_date: from_date,
            to_date: to_date
        })
    }).then(res => res.json()).
        then(data => {
            // console.log('data')
            // console.log(data)
            const response = data?.data ? data?.data : '';
            dispatch({ type: 'SET_EMP_PUNCH_TIME_IN_MONTH', payload: { response } })
        })
}

export const get_weekly_punch_in_time = (userId) => async (dispatch) => {
    var curr = new Date;
    var firstdayofWeek = moment().startOf('isoweek').format("YYYY-MM-DD");
    var lastdayOfWeek = moment().endOf('isoweek').format("YYYY-MM-DD");
    await fetch(SERVER_URL + `api/attendance/punch-time-in-week`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
            EmpID: userId,
            firstdayofWeek: firstdayofWeek,
            lastdayOfWeek: lastdayOfWeek
        })
    }).then(res => res.json()).
        then(data => {
            const week_hrs = data?.data ? data?.data : '';
            dispatch({ type: 'SET_EMP_PUNCH_TIME_IN_WEEK', payload: { week_hrs } })
        })
}
export const get_holidays = (month,year) => async (dispatch) => {
    await fetch(SERVER_URL + `api/attendance/get_holiday`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'authorization': `bearer ${token.value}`
        },
        body: JSON.stringify({
            month: month,
            year:year
        })
    }).then(res => res.json()).
        then(data => {
            const holiday = data?.data?.holidays ? data?.data?.holidays : '0';
            dispatch({ type: 'SET_COMPANY_HOLIDAY', payload: { holiday } })
        })
}